// SHA-256 hash so we never send the raw email/username to GA4
// (GA4 forbids PII in user_id).
export async function hashUserId(raw) {
  if (!raw) return null;
  const normalized = String(raw).trim().toLowerCase();
  const bytes = new TextEncoder().encode(normalized);
  const digest = await window.crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export function setGaUser(gaId, hashedId) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('config', gaId, { user_id: hashedId });
  window.gtag('set', 'user_properties', { crm_id: hashedId });
}

export function clearGaUser(gaId) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('config', gaId, { user_id: null });
  window.gtag('set', 'user_properties', { crm_id: null });
}
